<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
            name="Update Details"
            bc1="App"
            bc2="Currency"
            bc3="Update"
            path="currency"
          ></Breadcrumb>
        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Update Details</h4>
                </div>
                <div class="card-body">
                  <form class="form form-horizontal">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="name-icon">Name</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text"
                                  ><i class="far fa-user"></i
                                ></span>
                              </div>
                              <input
                                type="text"
                                v-model="name"
                                id="name-icon"
                                class="form-control"
                                :class="
                                  errorBag.has('name') ? 'is-invalid' : ''
                                "
                                name="name"
                                placeholder="Name"
                                v-validate="'required'"
                              />
                              <small
                                v-show="errorBag.has('name')"
                                class="invalid-feedback"
                                >{{ "*" + errorBag.first("name") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="symbol-icon">Symbol</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text"
                                  ><TargetIcon
                                /></span>
                              </div>
                              <input
                                type="text"
                                v-model="symbol"
                                id="symbol-icon"
                                class="form-control"
                                :class="
                                  errorBag.has('symbol') ? 'is-invalid' : ''
                                "
                                name="symbol"
                                placeholder="Symbol"
                                v-validate="'required'"
                              />
                              <small
                                v-show="errorBag.has('symbol')"
                                class="invalid-feedback"
                                >{{ "*" + errorBag.first("symbol") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>File</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <div class="row" v-if="!changeLogo">
                                <div class="col-md-6">
                                  <img
                                    width="50"
                                    height="50"
                                    :src="logoImage"
                                  />
                                </div>
                                <div class="col-md-6">
                                  <button
                                    class="btn btn-gradient-secondary btn-sm mt-1"
                                    @click="changeLogo = true"
                                  >
                                    Change
                                  </button>
                                </div>
                              </div>
                              <div class="custom-file" v-if="changeLogo">
                                <input
                                  type="file"
                                  class="custom-file-input"
                                  :class="
                                    errorBag.has('file') ? 'is-invalid' : ''
                                  "
                                  id="customFile1"
                                  name="file"
                                  @change="onFileChanged"
                                  v-validate="'required'"
                                />
                                <label
                                  class="custom-file-label"
                                  for="customFile1"
                                  >{{
                                    logo ? logo.name : "Choose icon image"
                                  }}</label
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Type</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <select
                                class="custom-select"
                                name="type"
                                v-model="type"
                                :class="
                                  errorBag.has('type') ? 'is-invalid' : ''
                                "
                                v-validate="'required'"
                              >
                                <option value="">Please select item</option>
                                <option value="fiat">Fiat</option>
                                <option value="crypto">Crypto</option>
                              </select>
                              <small
                                v-show="errorBag.has('type')"
                                class="invalid-feedback"
                                >{{ "*" + errorBag.first("type") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Exchange from</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <select
                                class="custom-select"
                                name="exchangeFrom"
                                v-model="exchangeFrom"
                                :class="
                                  errorBag.has('exchangeFrom')
                                    ? 'is-invalid'
                                    : ''
                                "
                                v-validate="'required'"
                              >
                                <option value="">Please select item</option>
                                <option value="local">Local</option>
                                <option value="api">Api</option>
                              </select>
                              <small
                                v-show="errorBag.has('exchangeFrom')"
                                class="invalid-feedback"
                                >{{
                                  "*" + errorBag.first("exchangeFrom")
                                }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="rate-icon">Rate</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text"
                                  ><Edit3Icon
                                /></span>
                              </div>
                              <input
                                type="text"
                                id="rate-icon"
                                class="form-control"
                                v-model="rate"
                                name="rate"
                                placeholder="Rate"
                                :class="
                                  errorBag.has('rate') ? 'is-invalid' : ''
                                "
                                v-validate="'required'"
                              />
                              <small
                                v-show="errorBag.has('rate')"
                                class="invalid-feedback"
                                >{{ "*" + errorBag.first("rate") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="rate-icon">Code</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text"
                                  ><Edit3Icon
                                /></span>
                              </div>
                              <input
                                type="text"
                                id="code-icon"
                                class="form-control"
                                v-model="code"
                                name="code"
                                placeholder="Code"
                                :class="
                                  errorBag.has('code') ? 'is-invalid' : ''
                                "
                                v-validate="'required'"
                              />
                              <small
                                v-show="errorBag.has('code')"
                                class="invalid-feedback"
                                >{{ "*" + errorBag.first("code") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-9 offset-sm-3 d-flex">
                        <button
                          type="button"
                          class="btn btn-primary mr-1 d-flex"
                          @click="sendCall"
                          :disabled="loading"
                        >
                          <Loader :loading="loading" :size="size"></Loader>
                          Save
                        </button>
                        <button
                          type="button"
                          class="btn btn-gradient-secondary"
                          @click="$emit('back')"
                        >
                          Back
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import { TargetIcon, Edit3Icon, CommandIcon } from "vue-feather-icons";

export default {
  components: {
    TargetIcon,
    Edit3Icon,
    CommandIcon
  },
  mounted() {
    let currencyUpdateData = this.$store.getters.getByKey("currencyUpdate");
    this.index = currencyUpdateData.index;
    this.id = currencyUpdateData.id;
    this.name = currencyUpdateData.name;
    this.logoImage = currencyUpdateData.logo;
    this.symbol = currencyUpdateData.symbol;
    this.type = currencyUpdateData.type;
    this.exchangeFrom = currencyUpdateData.exchange_from;
    this.rate = parseFloat(currencyUpdateData.rate/100).toFixed(2);
    this.code = currencyUpdateData.code;
  },
  data() {
    return {
      id: "",
      index: "",
      name: "",
      symbol: "",
      logo: null,
      type: "",
      exchangeFrom: "",
      rate: "",
      code: "",
      changeLogo: false,
      logoImage: "",
      loading: false,
      size: "10px"
    };
  },
  methods: {
    onFileChanged(event) {
      this.logo = event.target.files[0];
    },
    sendCall() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;

          var data = {
            id: this.id,
            name: this.name,
            symbol: this.symbol,
            type: this.type,
            exchangeFrom: this.exchangeFrom,
            rate: this.rate*100,
            code : this.code,
          }

          if (this.changeLogo) {
            let attachment = new FormData();
            attachment.append("logo", this.logo);
            data.hasAttachment = attachment

          }

          this.makeRequest("post", "v1/update-currency", data).then(
            callResponse => {
              if (!callResponse.error) {
                let code = callResponse.response.data.code;
                if (code == 200) {
                  this.loading = false;
                  if (callResponse.response.data.data) {
                    let responseData = callResponse.response.data.data;
                    let storeData = this.$store.getters.getByKey("currencyUpdate");
                    let rawdata = this.$store.getters.getTableData(storeData.storageKey+'_custom')
                    let rowProp = {
                      ...storeData,
                      ...responseData
                    }
                    // rowProp.name = responseData.name
                    // rowProp.symbol= responseData.symbol
                    // rowProp.type= responseData.type
                    // rowProp.exchange_from= responseData.exchangeFrom
                    // rowProp.rate = responseData.rate
                    // rowProp.code = responseData.code
                    // rowProp.logo = responseData.logo
                    rawdata[storeData.idx] = rowProp
                    this.$store.dispatch('setTableData', { key: storeData.storageKey+'_custom', data: {...rawdata} })

                    this.$emit('back')
                    return
                  }
                } else {
                  this.loading = false;
                }
              }
            }
          );
        }
      });
    }
  }
};
</script>

